import { createFiltersHelper } from "src/decidim/volunteering/shared/filters_helper";
$(() => {
  createFiltersHelper(document.getElementById("filters")).init();
  const showMoreDistrictsBtn = document.getElementById("show-more-districts");
  const showWithoutOffersCheckbox = document.querySelector(".show-without-offers-checkbox");
  const districtElements = document.querySelectorAll(".district_element");
  const districtCheckboxes = document.querySelectorAll('.district_element input[type="checkbox"]');
  showWithoutOffersCheckbox.addEventListener("click", () => {
    if (showWithoutOffersCheckbox.checked) {
      districtCheckboxes.forEach((checkbox) => checkbox.checked = false);
    }
  });
  districtCheckboxes.forEach((checkbox) => checkbox.addEventListener("click", (event) => {
    showWithoutOffersCheckbox.checked = false;
  }));
  showMoreDistrictsBtn.addEventListener("click", function() {
    const expanded = !(showMoreDistrictsBtn.dataset.expanded === "true");
    districtElements.forEach((item) => {
      if (item.dataset.hideable === "true") {
        item.classList.toggle("hidden");
      }
      showMoreDistrictsBtn.innerText = showMoreDistrictsBtn.getAttribute(expanded ? "data-hide" : "data-show");
      showMoreDistrictsBtn.setAttribute("data-expanded", expanded.toString());
    });
  });
});
